module.exports = __webpack_public_path__ + "reports-head.png?b48937bc9110402246552248c8b1f2a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reports-head.png
// module id = 55
// module chunks = 0